<template>
    <div class="yizhijia">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Home",
    data(){
        return{

        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
              this.$parent.$refs.openPop.openDialog(title,type);
          }
    }
}
</script>

<style scoped lang="less">

 .box1{
     width: 100px;
     height:100px;
     background: red;
     .box2{
         width: 50px;
         height:50px;
         background: green;
         .box3{
             width: 30px;
             height:30px;
             background: blue;
         }
     }
 }
</style>



// WEBPACK FOOTER //
// src/components/yizhijia.vue